<template>
  <div class="app flex-row align-items-center animated fadeIn">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4"><i class="fa fa-lock"></i></h1>
            <h4 class="pt-3">Houve um problema na sua requisição!</h4>
            <p class="text-muted">Você está tentando acessar um recurso sem autorização.</p>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <b-button variant="info" @click="voltarInicio()">Voltar para o início</b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NaoAutorizado',

  methods: {
    voltarInicio () {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
